"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _TicketCardWithManager = _interopRequireDefault(require("../TicketCardWithManager"));
var _excluded = ["tickets", "visible", "onSelect", "getOrderURLById"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ticketCardPropTypes = _TicketCardWithManager["default"].propTypes;
var TicketCardWithManagerList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var tickets = _ref.tickets,
    visible = _ref.visible,
    onSelect = _ref.onSelect,
    getOrderURLById = _ref.getOrderURLById,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isExpand = _useState2[0],
    setIsExpand = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsExpand(false);
  }, [tickets]);
  if ((0, _isEmpty2["default"])(tickets)) {
    return null;
  }
  var hasHidden = tickets.length > visible;
  var shownTickets = isExpand ? tickets : tickets.slice(0, visible);
  return /*#__PURE__*/_react["default"].createElement(StyledTicketsList, props, shownTickets.map(function (shownTicket) {
    var ticket = shownTicket.ticket,
      manager = shownTicket.manager;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: ticket.id
    }, /*#__PURE__*/_react["default"].createElement(StyledTicketCard, {
      manager: manager,
      getOrderURLById: getOrderURLById,
      ticket: ticket,
      onSelect: onSelect
    }), /*#__PURE__*/_react["default"].createElement(StyledSeparator, null));
  }), !isExpand && hasHidden && /*#__PURE__*/_react["default"].createElement(StyledShowMoreButton, {
    functional: true,
    onClick: setIsExpand
  }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435 \u0442\u0438\u043A\u0435\u0442\u044B"));
});
TicketCardWithManagerList.propTypes = {
  className: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool,
  tickets: _propTypes["default"].arrayOf(_propTypes["default"].shape(ticketCardPropTypes)).isRequired,
  visible: _propTypes["default"].number,
  onSelect: _propTypes["default"].func
};
TicketCardWithManagerList.defaultProps = {
  className: '',
  isLoading: true,
  visible: 3,
  onSelect: Function.prototype
};
TicketCardWithManagerList.displayName = 'TicketCardWithManagerList';
var StyledTicketsList = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardWithManagerList__StyledTicketsList",
  componentId: "sc-1viic5q-0"
})(["display:flex;padding:0 5px;flex-direction:column;"]);
var StyledTicketCard = (0, _styledComponents["default"])(_TicketCardWithManager["default"]).withConfig({
  displayName: "TicketCardWithManagerList__StyledTicketCard",
  componentId: "sc-1viic5q-1"
})(["height:auto;box-sizing:border-box;border-radius:2px;"]);
var StyledSeparator = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardWithManagerList__StyledSeparator",
  componentId: "sc-1viic5q-2"
})(["height:10px;"]);
var StyledShowMoreButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketCardWithManagerList__StyledShowMoreButton",
  componentId: "sc-1viic5q-3"
})(["margin-top:auto;color:#007aff;font-size:12px;padding:0 5px;text-align:left;z-index:10;"]);
var _default = exports["default"] = TicketCardWithManagerList;